var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLearningPatharrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 35,
    viewBox: "0 0 83 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1145 5.98434L42.5 0L36.907 5.96148C14.1435 9.71196 0 35 0 35C0 35 14.3338 10.4869 39.488 9.94649L39.4603 9.97345L45.5222 10.0265L45.5015 10.0056C68.0817 11.0175 82.2115 33.706 82.968 34.9471C82.1927 33.6722 67.4059 9.732 48.1145 5.98434ZM45.5015 10.0056C44.5297 9.96201 43.5424 9.9586 42.5397 9.99878C41.5055 9.94141 40.4882 9.925 39.488 9.94649L42.5175 7.00008L45.5015 10.0056Z",
    fill: "url(#paint0_linear_1509_29)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1509_29",
    x1: 41.484,
    y1: 0,
    x2: 41.484,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#55B0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225,
    stopColor: "#2183BA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearningPatharrow);
export default __webpack_public_path__ + "static/media/LearningPath arrow.5d83ed33.svg";
export { ForwardRef as ReactComponent };